/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
export default defineComponent({
  name: 'ListDataItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  setup: function setup() {
    return {};
  }
});